import { useToast } from '../../contexts/ToastContext';
import { copyToClipboard } from '../../utils/clipboard';
import { socialLinks } from '../../constants';
import { EmailIcon } from '../icons';

/**
 * Reusable email button that copies email to clipboard
 */
function EmailButton({ className = '', children, showIcon = true, ...props }) {
  const { showToast } = useToast();

  const handleClick = (e) => {
    e.preventDefault();
    copyToClipboard(socialLinks.email, showToast);
  };

  return (
    <button
      onClick={handleClick}
      className={className}
      aria-label="Copy email to clipboard"
      {...props}
    >
      {showIcon && <EmailIcon />}
      {children}
    </button>
  );
}

export default EmailButton;
